import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreRoutingModule } from './core-routing.module';

import { routeAnimation } from './animation/route.animation';
import { elementAnimation } from './animation/element.animation';

import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth.guard';
import { LocalStorageService } from './localStorage/local-storage.service';
import { DataService } from './data/data.service'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CoreRoutingModule
  ]
})
export class CoreModule { }
export {
  routeAnimation,
  elementAnimation,
  AuthService,
  AuthGuard,
  LocalStorageService,
  DataService,

}